<div [ngClass]="{ 'overlay': (dataSource.isLoading$ | async)}">
  @if (dataSource.isLoading$ | async) {
    <div class="w-full h-full flex justify-center items-center">
      <mat-spinner></mat-spinner>
    </div>
  }

  @if (!dataSource?.hasData && !(dataSource.isLoading$ | async)) {
    <app-notification-block
      [header]="'No metrics data available for the building'"
      [statusClass]="StatusClass.WARNING">
      Data is not available for the selected building. Please check the selected building and try again.
    </app-notification-block>
  }

  @if (!(dataSource.isLoading$ | async) && dataSource.hasData) {
    <div class='flex my-3'>
      <button data-cy='export-report-btn' class='action-btn' (click)='export()'
              mat-raised-button color='primary' matTooltip='Export filtered results'>
        <mat-icon aria-hidden='false' aria-label='Export'>list_alt</mat-icon>
        Export
      </button>
    </div>
  }

  <div class="overflow-x-auto">
    <mat-table class="overflow-auto mat-elevation-z8 w-[93vw] "
               [dataSource]="dataSource"
               [ngClass]="{'invisible': ((dataSource.isLoading$ | async) || !dataSource.hasData)}">
        <ng-container matColumnDef="activeEnergy">
          <mat-header-cell *matHeaderCellDef>Active Energy</mat-header-cell>
          <mat-cell [attr.data-cy]="'active-energy-cell-'+data.gtin" *matCellDef="let data">{{display(formattedNumber(data.activeEnergy), 'Wh')}}</mat-cell>
        </ng-container>
        <ng-container matColumnDef="activePower">
          <mat-header-cell *matHeaderCellDef>Active Power</mat-header-cell>
          <mat-cell [attr.data-cy]="'active-power-cell-'+data.gtin" *matCellDef="let data">{{display(formattedNumber(data.activePower), 'W')}}</mat-cell>
        </ng-container>
        <ng-container matColumnDef="controlGearOperatingTime">
          <mat-header-cell *matHeaderCellDef>CG Operating Time</mat-header-cell>
          <mat-cell [attr.data-cy]="'cg-operating-time-cell-'+data.gtin" *matCellDef="let data">{{display(formatDurationFromSeconds(data.controlGearOperatingTime))}}</mat-cell>
        </ng-container>
        <ng-container matColumnDef="controlGearStartCounter">
          <mat-header-cell *matHeaderCellDef>CG Start Counter</mat-header-cell>
          <mat-cell [attr.data-cy]="'cg-start-counter-cell-'+data.gtin" *matCellDef="let data">{{display(data.controlGearStartCounter)}}</mat-cell>
        </ng-container>
        <ng-container matColumnDef="controlGearExternalSupplyVoltage">
          <mat-header-cell *matHeaderCellDef>CG External Supply Voltage</mat-header-cell>
          <mat-cell [attr.data-cy]="'cg-external-supply-voltage-cell-'+data.gtin" *matCellDef="let data">{{display(formattedNumber(data.controlGearExternalSupplyVoltage), 'Vrms')}}</mat-cell>
        </ng-container>
        <ng-container matColumnDef="controlGearExternalSupplyVoltageFrequency">
          <mat-header-cell *matHeaderCellDef>CG External Supply Voltage Frequency</mat-header-cell>
          <mat-cell [attr.data-cy]="'cg-external-supply-voltage-frequency-cell-'+data.gtin" *matCellDef="let data">{{display(data.controlGearExternalSupplyVoltageFrequency,'Hz') }}</mat-cell>
        </ng-container>
        <ng-container matColumnDef="controlGearPowerFactor">
          <mat-header-cell *matHeaderCellDef>CG Power Factor</mat-header-cell>
          <mat-cell [attr.data-cy]="'cg-power-factor-cell-'+data.gtin" *matCellDef="let data">{{display(formattedNumber(data.controlGearPowerFactor))}}</mat-cell>
        </ng-container>
        <ng-container matColumnDef="controlGearOverallFailureCondition">
          <mat-header-cell *matHeaderCellDef>CG Overall Failure Condition</mat-header-cell>
          <mat-cell [attr.data-cy]="'cg-overall-failure-condition-cell-'+data.gtin" *matCellDef="let data">{{formattedBoolean(data.controlGearOverallFailureCondition)}}</mat-cell>
        </ng-container>
        <ng-container matColumnDef="controlGearOverallFailureConditionCounter">
          <mat-header-cell *matHeaderCellDef>CG Overall Failure Condition Counter</mat-header-cell>
          <mat-cell [attr.data-cy]="'cg-overall-failure-condition-counter-cell-'+data.gtin" *matCellDef="let data">{{display(data.controlGearOverallFailureConditionCounter)}}</mat-cell>
        </ng-container>
        <ng-container matColumnDef="controlGearExternalSupplyUndervoltage">
          <mat-header-cell *matHeaderCellDef>CG External Supply Under Voltage</mat-header-cell>
          <mat-cell [attr.data-cy]="'cg-external-supply-under-voltage-cell-'+data.gtin" *matCellDef="let data">{{display(formattedBoolean(data.controlGearExternalSupplyUndervoltage))}}</mat-cell>
        </ng-container>
        <ng-container matColumnDef="controlGearExternalSupplyUndervoltageCounter">
          <mat-header-cell *matHeaderCellDef>CG External Supply Under Voltage Counter</mat-header-cell>
          <mat-cell [attr.data-cy]="'cg-external-supply-under-voltage-counter-cell-'+data.gtin" *matCellDef="let data">{{display(data.controlGearExternalSupplyUndervoltageCounter)}}</mat-cell>
        </ng-container>
        <ng-container matColumnDef="controlGearExternalSupplyOvervoltage">
          <mat-header-cell *matHeaderCellDef>CG External Supply Over Voltage</mat-header-cell>
          <mat-cell [attr.data-cy]="'cg-external-supply-over-voltage-cell-'+data.gtin" *matCellDef="let data">{{display(formattedBoolean(data.controlGearExternalSupplyOvervoltage))}}</mat-cell>
        </ng-container>
        <ng-container matColumnDef="controlGearExternalSupplyOvervoltageCounter">
          <mat-header-cell *matHeaderCellDef>CG External Supply Over Voltage Counter</mat-header-cell>
          <mat-cell [attr.data-cy]="'cg-external-supply-over-voltage-counter-cell-'+data.gtin" *matCellDef="let data">{{display(data.controlGearExternalSupplyOvervoltageCounter)}}</mat-cell>
        </ng-container>
        <ng-container matColumnDef="controlGearOutputPowerLimitation">
          <mat-header-cell *matHeaderCellDef>CG Output Power Limitation</mat-header-cell>
          <mat-cell [attr.data-cy]="'cg-output-power-limitation-cell-'+data.gtin" *matCellDef="let data">{{display(formattedBoolean(data.controlGearOutputPowerLimitation))}}</mat-cell>
        </ng-container>
        <ng-container matColumnDef="controlGearOutputPowerLimitationCounter">
          <mat-header-cell *matHeaderCellDef>CG Output Power Limitation Counter</mat-header-cell>
          <mat-cell [attr.data-cy]="'cg-output-power-limitation-counter-cell-'+data.gtin" *matCellDef="let data">{{display(data.controlGearOutputPowerLimitationCounter)}}</mat-cell>
        </ng-container>
        <ng-container matColumnDef="controlGearThermalDerating">
          <mat-header-cell *matHeaderCellDef>CG Thermal Derating</mat-header-cell>
          <mat-cell [attr.data-cy]="'cg-thermal-derating-cell-'+data.gtin" *matCellDef="let data">{{display(formattedBoolean(data.controlGearThermalDerating))}}</mat-cell>
        </ng-container>
        <ng-container matColumnDef="controlGearThermalDeratingCounter">
          <mat-header-cell *matHeaderCellDef>CG Thermal Derating Counter</mat-header-cell>
          <mat-cell [attr.data-cy]="'cg-thermal-derating-counter-cell-'+data.gtin" *matCellDef="let data">{{display(data.controlGearThermalDeratingCounter)}}</mat-cell>
        </ng-container>
        <ng-container matColumnDef="controlGearThermalShutdown">
          <mat-header-cell *matHeaderCellDef>CG Thermal Shutdown</mat-header-cell>
            <mat-cell [attr.data-cy]="'cg-thermal-shutdown-cell-'+data.gtin" *matCellDef="let data">{{display(formattedBoolean(data.controlGearThermalShutdown))}}</mat-cell>
        </ng-container>
        <ng-container matColumnDef="controlGearThermalShutdownCounter">
          <mat-header-cell *matHeaderCellDef>CG Thermal Shutdown Counter</mat-header-cell>
          <mat-cell [attr.data-cy]="'cg-thermal-shutdown-counter-cell-'+data.gtin" *matCellDef="let data">{{display(data.controlGearThermalShutdownCounter)}}</mat-cell>
        </ng-container>
        <ng-container matColumnDef="controlGearTemperature">
          <mat-header-cell *matHeaderCellDef>CG Temperature</mat-header-cell>
          <mat-cell [attr.data-cy]="'cg-temperature-cell-'+data.gtin" *matCellDef="let data">{{display(data.controlGearTemperature, '°C') }}</mat-cell>
        </ng-container>
        <ng-container matColumnDef="controlGearOutputCurrentPercent">
          <mat-header-cell *matHeaderCellDef>CG Output Current Percent</mat-header-cell>
          <mat-cell [attr.data-cy]="'cg-output-current-percent-cell-'+data.gtin" *matCellDef="let data">{{display(data.controlGearOutputCurrentPercent, '%')}}</mat-cell>
        </ng-container>
        <ng-container matColumnDef="lightSourceStartCounterResettable">
          <mat-header-cell *matHeaderCellDef>Light Source Start Counter Resettable</mat-header-cell>
          <mat-cell [attr.data-cy]="'light-source-start-counter-resettable-cell-'+data.gtin" *matCellDef="let data">{{display(data.lightSourceStartCounterResettable)}}</mat-cell>
        </ng-container>
        <ng-container matColumnDef="lightSourceStartCounter">
          <mat-header-cell *matHeaderCellDef>Light Source Start Counter</mat-header-cell>
          <mat-cell [attr.data-cy]="'light-source-start-counter-cell-'+data.gtin" *matCellDef="let data">{{display(data.lightSourceStartCounter)}}</mat-cell>
        </ng-container>
        <ng-container matColumnDef="lightSourceOnTimeResettable">
          <mat-header-cell *matHeaderCellDef>Light Source On Time Resettable</mat-header-cell>
          <mat-cell [attr.data-cy]="'light-source-on-time-resettable-cell-'+data.gtin" *matCellDef="let data">{{display(formatDurationFromSeconds(data.lightSourceOnTimeResettable))}}</mat-cell>
        </ng-container>
        <ng-container matColumnDef="lightSourceOnTime">
          <mat-header-cell *matHeaderCellDef>Light Source On Time</mat-header-cell>
          <mat-cell [attr.data-cy]="'light-source-on-time-cell-'+data.gtin" *matCellDef="let data">{{display(formatDurationFromSeconds(data.lightSourceOnTime))}}</mat-cell>
        </ng-container>
        <ng-container matColumnDef="lightSourceVoltage">
          <mat-header-cell *matHeaderCellDef>Light Source Voltage</mat-header-cell>
          <mat-cell [attr.data-cy]="'light-source-voltage-cell-'+data.gtin" *matCellDef="let data">{{display(formattedNumber(data.lightSourceVoltage), 'V')}}</mat-cell>
        </ng-container>
        <ng-container matColumnDef="lightSourceCurrent">
          <mat-header-cell *matHeaderCellDef>Light Source Current</mat-header-cell>
          <mat-cell [attr.data-cy]="'light-source-current-cell-'+data.gtin" *matCellDef="let data">{{display(formattedNumber(data.lightSourceCurrent), 'A')}}</mat-cell>
        </ng-container>
        <ng-container matColumnDef="lightSourceOverallFailureCondition">
          <mat-header-cell *matHeaderCellDef>Light Source Overall Failure Condition</mat-header-cell>
          <mat-cell [attr.data-cy]="'light-source-overall-failure-condition-cell-'+data.gtin" *matCellDef="let data">{{display(formattedBoolean(data.lightSourceOverallFailureCondition))}}</mat-cell>
        </ng-container>
        <ng-container matColumnDef="lightSourceOverallFailureConditionCounter">
          <mat-header-cell *matHeaderCellDef>Light Source Overall Failure Condition Counter</mat-header-cell>
          <mat-cell [attr.data-cy]="'light-source-overall-failure-condition-counter-cell-'+data.gtin" *matCellDef="let data">{{display(data.lightSourceOverallFailureConditionCounter)}}</mat-cell>
        </ng-container>
        <ng-container matColumnDef="lightSourceShortCircuit">
          <mat-header-cell *matHeaderCellDef>Light Source Short Circuit</mat-header-cell>
          <mat-cell [attr.data-cy]="'light-source-short-circuit-cell-'+data.gtin" *matCellDef="let data">{{display(formattedBoolean(data.lightSourceShortCircuit))}}</mat-cell>
        </ng-container>
        <ng-container matColumnDef="lightSourceShortCircuitCounter">
          <mat-header-cell *matHeaderCellDef>Light Source Short Circuit Counter</mat-header-cell>
          <mat-cell [attr.data-cy]="'light-source-short-circuit-counter-cell-'+data.gtin" *matCellDef="let data">{{display(data.lightSourceShortCircuitCounter)}}</mat-cell>
        </ng-container>
        <ng-container matColumnDef="lightSourceOpenCircuit">
          <mat-header-cell *matHeaderCellDef>Light Source Open Circuit</mat-header-cell>
          <mat-cell [attr.data-cy]="'light-source-open-circuit-cell-'+data.gtin" *matCellDef="let data">{{display(formattedBoolean(data.lightSourceOpenCircuit))}}</mat-cell>
        </ng-container>
        <ng-container matColumnDef="lightSourceOpenCircuitCounter">
          <mat-header-cell *matHeaderCellDef>Light Source Open Circuit Counter</mat-header-cell>
          <mat-cell [attr.data-cy]="'light-source-open-circuit-counter-cell-'+data.gtin" *matCellDef="let data">{{display(data.lightSourceOpenCircuitCounter)}}</mat-cell>
        </ng-container>
        <ng-container matColumnDef="lightSourceThermalDerating">
          <mat-header-cell *matHeaderCellDef>Light Source Thermal Derating</mat-header-cell>
          <mat-cell [attr.data-cy]="'light-source-thermal-derating-cell-'+data.gtin" *matCellDef="let data">{{display(formattedBoolean(data.lightSourceThermalDerating))}}</mat-cell>
        </ng-container>
        <ng-container matColumnDef="lightSourceThermalDeratingCounter">
          <mat-header-cell *matHeaderCellDef>Light Source Thermal Derating Counter</mat-header-cell>
          <mat-cell [attr.data-cy]="'light-source-thermal-derating-counter-cell-'+data.gtin" *matCellDef="let data">{{display(data.lightSourceThermalDeratingCounter)}}</mat-cell>
        </ng-container>
        <ng-container matColumnDef="lightSourceThermalShutdown">
          <mat-header-cell *matHeaderCellDef>Light Source Thermal Shutdown</mat-header-cell>
          <mat-cell [attr.data-cy]="'light-source-thermal-shutdown-cell-'+data.gtin" *matCellDef="let data">{{display(formattedBoolean(data.lightSourceThermalShutdown))}}</mat-cell>
        </ng-container>
        <ng-container matColumnDef="lightSourceThermalShutdownCounter">
          <mat-header-cell *matHeaderCellDef>Light Source Thermal Shutdown Counter</mat-header-cell>
          <mat-cell [attr.data-cy]="'light-source-thermal-shutdown-counter-cell-'+data.gtin" *matCellDef="let data">{{display(data.lightSourceThermalShutdownCounter)}}</mat-cell>
        </ng-container>
        <ng-container matColumnDef="lightSourceTemperature">
          <mat-header-cell *matHeaderCellDef>Light Source Temperature</mat-header-cell>
          <mat-cell [attr.data-cy]="'light-source-temperature-cell-'+data.gtin" *matCellDef="let data">{{display(data.lightSourceTemperature, '°C') }}</mat-cell>
        </ng-container>
        <ng-container matColumnDef="daliBusPowerSupplyStatus">
          <mat-header-cell *matHeaderCellDef>Dali Bus Power Supply Status</mat-header-cell>
          <mat-cell [attr.data-cy]="'dali-bus-power-supply-status-cell-'+data.gtin" *matCellDef="let data">{{display(data.daliBusPowerSupplyStatus)}}</mat-cell>
        </ng-container>
        <ng-container matColumnDef="nodeId">
          <mat-header-cell *matHeaderCellDef>Node Id</mat-header-cell>
          <mat-cell [attr.data-cy]="'node-id-cell-'+data.gtin" *matCellDef="let data">
            <a [attr.data-cy]="'adm-node-link-' + data.nodeId" class="text-blue-600 cursor-pointer" (click)="navigateToUrl(data.sensorNodeLink)">
              {{data.nodeId}}
            </a>
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="driverIdentificationNumber">
          <mat-header-cell *matHeaderCellDef>Driver Identification Number</mat-header-cell>
          <mat-cell [attr.data-cy]="'driver-identification-number-cell-'+data.gtin" *matCellDef="let data" [matTooltip]="data.driverIdentificationNumber"
                    matTooltipPosition="above" >{{data.driverIdentificationNumber}}</mat-cell>
        </ng-container>
        <ng-container matColumnDef="gtin">
          <mat-header-cell *matHeaderCellDef>GTIN</mat-header-cell>
          <mat-cell [attr.data-cy]="'gtin-cell-'+data.gtin" *matCellDef="let data">{{data.gtin}}</mat-cell>
        </ng-container>
        <ng-container matColumnDef="time">
          <mat-header-cell *matHeaderCellDef>Time</mat-header-cell>
          <mat-cell [attr.data-cy]="'time-cell-'+data.gtin" *matCellDef="let data">{{formattedDate(data.time)}}</mat-cell>
        </ng-container>
      <mat-header-row *matHeaderRowDef="metricsTableColumns; sticky: true"></mat-header-row>
      <mat-row *matRowDef="let row; columns: metricsTableColumns" data-cy="log-row"></mat-row>
    </mat-table>
    @if (dataSource) {
      <mat-paginator [ngClass]="{'invisible': ((dataSource.isLoading$ | async) || !dataSource.hasData)}"
                     data-cy="logs-table-paginator"
                     class="mat-elevation-z8"
                     [length]="dataSource.counter$ | async"
                     [pageSizeOptions]="[10 , 20 , 50, 100]"
                     [pageSize]='pageSize'
                     [pageIndex]='pageNumber'
                      (page)="loadLogsFromPaginator($event)"
                     showFirstLastButtons
                     aria-label="Select page for logs">
      </mat-paginator>
    }
  </div>
</div>

